/* erx-bf-box: behaviour of the Black Mystery Box block (snippets/erx-bf-box.liquid).
   1. Stock feed freshness: the counts come only from the shop metafield ergonix.bf_box_stock; its updated_at is on the
      block. Under 60 min old: live dot + "atnaujinta prieš N min." (lv/et words from the sheet's data attributes). 60 min to 24 h: counts stay, dot and label go.
      Over 24 h, in the future or unreadable: the feed is treated as dead. Then the whole box goes (banner, strip, sheet,
      the Black Friday top line), unless the separately approved no-feed variant is switched
      on (bf_box_nofeed_ok -> data-erx-bfx-nofeed-ok), which shows the "no feed" lines instead of counts.
   2. The "Kas gali būti dėžėje?" sheet: native <dialog>; showModal() gives the top layer, Esc and an inert page; we add
      backdrop click, the scroll lock and focus return. Opens from the banner and the strip link; closes on "Supratau",
      the backdrop and Esc.
   Nothing else on the page is changed: sticky bar, tabs, pickers and add-ons behave exactly as live. */
(function () {
  var FRESH_MIN = 60, DEAD_MIN = 1440;
  var box = document.querySelector('[data-erx-bfx]');
  var sheet = document.querySelector('[data-erx-bfx-sheet]');
  /* the home hero's block (part 'home') has no sheet: it gets the same feed checks (1.) and nothing else */
  if (!box) return;
  if (sheet && sheet.parentNode !== document.body) document.body.appendChild(sheet);
  var html = document.documentElement, opener = null;

  /* ---- 1. feed freshness ---- */
  var gone = false;
  var setState = function (live) {
    if (!live && !box.hasAttribute('data-erx-bfx-nofeed-ok')) { drop(); return; }
    [box, sheet].forEach(function (el) { if (el) { el.classList.toggle('is-live', live); el.classList.toggle('is-nofeed', !live); } });
  };
  /* dead feed, no approved no-feed variant: remove the box and give the page back exactly as it is without it */
  var drop = function () {
    if (gone) return; gone = true;
    if (sheet && sheet.open && typeof sheet.close === 'function') sheet.close();
    box.remove(); if (sheet) sheet.remove(); html.classList.remove('erx-bfx-lock');
    /* the add-ons gift row and the hidden -% chip belong to the box too (launch audit 2026-11-01) */
    document.querySelectorAll('.erx-bfx-gift').forEach(function (g) { g.remove(); }); html.classList.add('erx-bfx-off');
    document.querySelectorAll('.erx-bfx-ann').forEach(function (a) {
      var p = a.querySelector('p'), o = a.getAttribute('data-erx-bfx-orig');
      if (p && o !== null) p.innerHTML = o;
      a.classList.remove('erx-bfx-ann');
    });
  };
  var fresh = function () {
    if (gone || !box.classList.contains('is-live')) return;
    var t = Date.parse(box.getAttribute('data-erx-bfx-updated') || '');
    var m = Math.floor((Date.now() - t) / 60000);
    if (isNaN(t) || m < -5 || m >= DEAD_MIN) { setState(false); return; }
    m = Math.max(0, m);
    var on = m < FRESH_MIN;
    document.querySelectorAll('[data-erx-bfx-dot]').forEach(function (d) { d.hidden = !on; });
    var up = sheet && sheet.querySelector('[data-erx-bfx-up]');
    if (up) {
      /* words per language from the sheet (snippets/erx-bf-box.liquid, lt/lv/et); lt default = the launch copy */
      var wNow = sheet.getAttribute('data-erx-bfx-upd-now') || 'atnaujinta ką tik';
      var wMin = sheet.getAttribute('data-erx-bfx-upd-min') || 'atnaujinta prieš %M% min.';
      up.textContent = m < 1 ? wNow : wMin.replace('%M%', m);
      up.hidden = !on;
    }
  };
  fresh();
  var tick = setInterval(function () { fresh(); if (gone) clearInterval(tick); }, 30000);
  if (gone || !sheet) return;

  /* ---- 2. sheet ---- */
  var lock = function (on) {
    /* overflow hidden on <html> with the scrollbar's space kept (CSS), so the page behind the dim does not move */
    html.classList.toggle('erx-bfx-lock', on);
  };
  /* last input was a key (Tab/Enter/Space/Esc) rather than a pointer: decides whether the returned focus shows a ring */
  var kbd = false;
  document.addEventListener('keydown', function () { kbd = true; }, true);
  document.addEventListener('pointerdown', function () { kbd = false; }, true);
  var open = function (e) {
    opener = e && e.currentTarget || null;
    fresh();
    if (typeof sheet.showModal === 'function') sheet.showModal(); else sheet.setAttribute('open', '');
    lock(true);
    var h = sheet.querySelector('#erx-bfx-sheet-h');
    if (h) h.focus({ preventScroll: true });
  };
  var close = function () {
    if (typeof sheet.close === 'function' && sheet.open) sheet.close(); else { sheet.removeAttribute('open'); onClose(); }
  };
  var onClose = function () {
    lock(false);
    /* focus goes back to the opener; CSS draws a ring there only for keyboard focus (:focus-visible) */
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true, focusVisible: kbd });
    opener = null;
  };
  document.querySelectorAll('[data-erx-bfx-open]').forEach(function (b) { b.addEventListener('click', open); });
  sheet.querySelectorAll('[data-erx-bfx-close]').forEach(function (b) { b.addEventListener('click', close); });
  sheet.addEventListener('close', onClose);
  /* the dialog box is the panel itself, so a click whose target is the <dialog> landed on the backdrop */
  sheet.addEventListener('click', function (e) { if (e.target === sheet) close(); });
  /* Esc without showModal support */
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.open && typeof sheet.showModal !== 'function') close(); });

})();
